'use client';

import React, { useState, useEffect } from 'react';

import { useModal } from '@/contexts/ModalContext';
import CircularUniform from '@/components/common/CircularUniform';
import ProfileModal from '@/components/common/ProfileModal';
import NoteStars from '@/components/common/NoteStars';
import { UserModel } from '@/types/users';
import { TeamMemberGlobalContextModel } from '@/types/teams';
import { FootballerProfileJson } from '@/types/users';

interface LoginCardProps {
  propsUser: UserModel | undefined;
  propsUserTeams: TeamMemberGlobalContextModel[] | undefined;
  propsShowBadge?: boolean;
  onToggleMenu?: () => void;
  menuButtonRef?: React.RefObject<HTMLButtonElement>;
}

const LoginCard: React.FC<LoginCardProps> = ({
  propsUser,
  propsUserTeams,
  propsShowBadge,
  onToggleMenu,
  menuButtonRef
}) => {
  /**
   * React Context
   */
  const { openModal, closeModal } = useModal();

  /**
   * useState
   */
  const [footballerProfile, setFootballerProfile] = useState<FootballerProfileJson | undefined>(
    propsUser ? (JSON.parse(propsUser.footballer.footballer_json) as FootballerProfileJson) : undefined
  );

  useEffect(() => {
    setFootballerProfile(
      propsUser ? (JSON.parse(propsUser.footballer.footballer_json) as FootballerProfileJson) : undefined
    );
  }, [propsUser]);

  return (
    <>
      <div
        className="flex rounded-xl shadow font-footballlog p-4 bg-cover bg-center "
        style={{ backgroundImage: "url('/images/profile.jpg')" }}>
        {propsUser ? (
          <div className="flex justify-between items-center w-full">
            <div
              className="flex justify-start items-center text-white hover:text-blue-500 cursor-pointer"
              onClick={() =>
                openModal(
                  <ProfileModal closeModal={closeModal} propsUser={propsUser} propsUserTeams={propsUserTeams} />
                )
              }>
              <CircularUniform uniformJsonString={propsUser.uniforms[0]?.uniform_json} />
              <div className="ms-2">
                <div className="font-footballlog text-xl mb-1">
                  <div className="">{propsUser.account_name}</div>
                </div>
                <div className="flex justify-start items-center w-fit">
                  <div className="text-white rounded w-fit text-xs italic">{footballerProfile?.numberOfLogs} Notes</div>
                  {Number(footballerProfile?.numberOfLogs) >= 100 && (
                    <div className="ms-1">
                      <NoteStars propsNumberOfLogs={Number(footballerProfile?.numberOfLogs)} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            {onToggleMenu != null && (
              <button
                type="button"
                ref={menuButtonRef}
                onClick={onToggleMenu}
                className="relative border border-white rounded-full text-white p-1 hover:border-blue-500 hover:text-blue-500 dark:hover:text-blue-700">
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke="currentColor" strokeLinecap="round" strokeWidth="3" d="M6 12h.01m6 0h.01m5.99 0h.01" />
                </svg>
                {propsShowBadge && (
                  <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full border border-white bg-blue-500"></div>
                )}
              </button>
            )}
          </div>
        ) : (
          <div className="flex justify-start items-center">
            <div className="w-10 h-10 bg-gray-600/50 rounded-full "></div>
            <div className="ms-2">
              <div className="w-32 h-3 bg-gray-600/50 rounded-full mb-1"></div>
              <div className="w-10 h-3 bg-gray-600/50 rounded-full "></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LoginCard;
